import styled, { css } from 'styled-components'
import fadeIn from '../../../styles/animations/fadeIn'
import { darken } from 'polished'

interface FieldProps {
  readonly error: boolean
}

export const Container = styled.div`
  ${fadeIn};
  height: 100%;
`

export const Content = styled.div<any>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0px 10px;
  border-radius: 10px;
  background: ${({ theme }) => darken(-0.6, theme.colors.primary)};
  color: ${({ theme }) => theme.colors.input};
`
